import {
  login,
  logout,
  setUsername,
  isAuthenticated,
  setUserId,
  api,
  getToken,
} from '../services';
import {
  PERMISSAO_TELA_ESCALAS_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR,
  PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR,
  PERMISSAO_TELA_GRADE_HORARIOS_LISTAR,
  PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR,
  PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR,
} from '../utils/dadosTelas';

let permissoesEmMemoria = null;
let permissoesAtualizadasEm = null;

const TEMPO_CACHE_PERMISSOES = 5 * 60 * 1000; // 5 minutos

export default {
  login: async ({ username, password }) => {
    try {
      const response = await api.post('/login/gerencial', {
        username,
        password,
      });
      if (response.status < 200 || response.status >= 300) {
        throw new Error('Erro inesperado');
      }
      const {
        token,
        refreshToken,
        user_id,
        request_status,
        message,
      } = response.data;
      if (request_status) {
        login(token, refreshToken);
        setUsername(username);
        setUserId(user_id);
      } else {
        throw new Error(message);
      }
    } catch (e) {
      throw e;
    }
  },

  logout: async () => {
    const response = await api.delete('/logout/gerencial');
    permissoesEmMemoria = null;
    permissoesAtualizadasEm = null;
    if (response.status < 200 || response.status >= 300) {
      throw new Error(response.statusText);
    }
    logout();
  },

  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      permissoesEmMemoria = null;
      permissoesAtualizadasEm = null;
      logout();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: () => (isAuthenticated() ? Promise.resolve() : Promise.reject()),

  getPermissions: async () => {
    try {
      const agora = Date.now();

      const cacheValido =
        permissoesEmMemoria &&
        permissoesAtualizadasEm &&
        agora - permissoesAtualizadasEm < TEMPO_CACHE_PERMISSOES;

      if (cacheValido) {
        return { ...permissoesEmMemoria, publico: true };
      }

      const response = await api.get('/get_permissoes', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      const { data, message } = response.data;

      if (message === 'Token inválido ou expirado' || !data) {
        permissoesEmMemoria = null;
        permissoesAtualizadasEm = null;
        logout();
        return Promise.reject();
      }

      permissoesEmMemoria = data.permissoes;
      permissoesAtualizadasEm = Date.now();

      permissoesEmMemoria[PERMISSAO_TELA_ESCALAS_LISTAR] = true;
      permissoesEmMemoria[PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR] = true;
      if (data.is_gestor) {
        permissoesEmMemoria[PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR] = true;
      }
      permissoesEmMemoria[PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR] = true;
      permissoesEmMemoria[PERMISSAO_TELA_GRADE_HORARIOS_LISTAR] = true;
      if (data.is_responsavel) {
        permissoesEmMemoria[PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR] = true;
      }
      permissoesEmMemoria[PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR] = true;

      permissoesEmMemoria.publico = true;

      return permissoesEmMemoria;
    } catch (e) {
      const status = e?.response?.status;
      const erroDeAutenticacao = status === 401 || status === 403;

      if (erroDeAutenticacao) {
        permissoesEmMemoria = null;
        permissoesAtualizadasEm = null;
        logout();
        throw e;
      }

      // Erro de rede (sem internet): devolve cache desatualizado se existir
      // para não deslogar o usuário no meio de uma tarefa
      if (permissoesEmMemoria) {
        return { ...permissoesEmMemoria, publico: true };
      }

      throw e;
    }
  },
};
